import elred_logo from '../Images/elred.svg'
import login_screen from './login.png'
export const Images = {
    ELRED_LOGO: elred_logo,
    LOGIN_SCREEN: login_screen,
}